import React from 'react'
import AppLayout from 'components/AppLayout'
import { AppTable } from 'components/AppTable'
import AppDialog from 'components/AppDialog'
import api, { AppModuleGroup, AppModule, ModuleGrid } from 'api'
import { RouteComponentProps } from 'react-router'
import ModuleGroupEdit from './ModuleGroupEdit'
import ModuleEdit from './ModuleEdit'
import AppTableAction from 'components/AppAction/AppTableAction'
import {appModule as appModulePromiss } from 'services/module'

export default class extends React.Component<RouteComponentProps<any> & IPage> {
	state = {
		currSystemCode: appModulePromiss.getCurrentModelingSystem().code,
	}

	reLoad = () => {
		this.refTable && this.refTable.current && this.refTable.current.refreshData()
	}
	// 一级模块新增
	newModuleGroup = () => {
		let systemCode = appModulePromiss.getCurrentModelingSystem().code
		let appModuleGroup: AppModuleGroup = {
			application: systemCode,
			code: '',
			fullCode: systemCode,
			icon: '',
			metadataVersion: '0.1',
			name: '',
			parentCode: systemCode,
		}
		AppDialog.open(<ModuleGroupEdit mode={1} appModuleGroup={appModuleGroup} afterSave={this.reLoad} />, {
			title: '新增一级模块',
			height: 320,
		})
	}
	// 编辑
	editModuleGroup = async (data: any) => {
		if (data.level === 1) {
			let appModuleGroup = await api.modeling.module.getGroup({ id: data.id, systemCode: data.application })
			AppDialog.open(<ModuleGroupEdit mode={2} appModuleGroup={appModuleGroup} afterSave={this.reLoad} />, {
				title: '编辑一级模块',
				height: 320,
			})
		} else {
			let appModule: AppModule = await api.modeling.module.getModule({
				id: data.id,
				systemCode: data.application,
			})
			console.log('appModule', appModule)
			AppDialog.open(<ModuleEdit mode={2} appModule={appModule} afterSave={this.reLoad} />, {
				title: '编辑二级模块',
				height: 600,
				width: 600,
			})
		}
	}
	// 新增二级模块
	newModule = (data: ModuleGrid) => {
		let appModule: AppModule = {
			appActionList: [],
			application: data.application,
			code: '',
			enabled: 1,
			fullCode: '',
			metadataVersion: '0.1',
			name: '',
			parentCode: data.fullCode,
			parentId: data.id,
			sort: '',
			url: '',
		}
		AppDialog.open(<ModuleEdit mode={1} appModule={appModule} afterSave={this.reLoad} />, {
			title: '新增二级模块',
			height: 600,
			width: 600,
		})
	}
	refTable = React.createRef<AppTable>()

	render() {
		let systemCode = appModulePromiss.getCurrentModelingSystem().code
		return (
			<AppLayout mode="col">
				<div
					className="add-module"
					style={{
						marginLeft: '0',
						alignSelf: 'flex-end',
						marginBottom: '15px',
					}}
					onClick={this.newModuleGroup}
				>
					<i></i>
					<span>新增一级模块</span>
				</div>
				<AppLayout.ColFix>
					<AppTable ref={this.refTable} api={api.modeling.module.getModuleGrid} data={{ systemCode }}>
						<AppTable.ColIndex />
						<AppTable.Col title="模块" field="name" width={200} expand />
						<AppTable.Col title="模块编码" field="showCode" width={200} />
						<AppTable.Col title="修改人" field="modifiedBy" width={200} />
						<AppTable.ColDate title="修改时间" field="modifiedOn" width={150} />
						<AppTable.ColAction
							render={(data: ModuleGrid) => {
								return (
									<React.Fragment>
										<AppTableAction
											onClick={() => {
												this.editModuleGroup(data)
											}}
											label="编辑"
										/>
										{data.level === 1 ? (
											<AppTableAction label="新增二级模块" onClick={() => this.newModule(data)} />
										) : null}
									</React.Fragment>
								)
							}}
						/>
					</AppTable>
				</AppLayout.ColFix>
			</AppLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/module/ModulePage.tsx